/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransazioneVoucherErrataCorrigeForm { 
    id_transazione: string;
    numero_scontrino?: string;
    valore_scontrino: number;
    version: number;
}

